<div class="container">
    <!-- {{overallRiskChangePercentage}}<br/> {{OverallRiskScoresByDateRange}} -->
    <!-- <mat-grid-list [cols]="gridCols" rowHeight="200px" gutterSize="16px">
        <mat-grid-tile *ngFor="let status of riskStatuses">
            <mat-card class="status-card">
                <mat-card-title>{{ status.label }}</mat-card-title>
                <mat-card-content>
                    <div class="status-count">{{ status.count }}</div>
                </mat-card-content>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list> -->

    <mat-card class="performance-card">
        <mat-card-title>Performance Indicators</mat-card-title>
        <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="130px" gutterSize="16px">
            <mat-grid-tile *ngFor="let indicator of performanceIndicators">
                <mat-card [ngClass]="getClass(indicator.label)" [matTooltip]="getTooltip(indicator)"  matTooltipPosition="above" class="indicator-box">
                    <div class="box-header">
                        <span>{{ indicator.label }}</span>
                        <mat-icon>{{ getIcon(indicator.label) }}</mat-icon>
                    </div>
                    <div class="value">{{ indicator.value }}</div>
                    <div class="subtext" *ngIf="indicator.subtext">{{ indicator.subtext }}</div>
                </mat-card>
            </mat-grid-tile>
        </mat-grid-list>
    </mat-card>

    <div class="score-performance-wrapper">
        <mat-card class="realtime-risk-card">
            <div class="card-header">
                <h2>Real-Time Risk Score</h2>
            </div>

            <div class="content-container">
                <div class="score-container">
                    <mat-progress-spinner class="risk-spinner" [ngClass]="getRiskColor() + '-spinner'"
                        [value]="overallScore / 10" [diameter]="200" mode="determinate" [strokeWidth]="12">
                    </mat-progress-spinner>

                    <div class="score-overlay">
                        <h1 [ngClass]="getRiskColor() + '-text'">{{ overallScore }}</h1>
                        <p>Real-Time Risk Score</p>
                    </div>
                </div>

            </div>
            <div class="score-details">
                <p [ngClass]="{ positive: overallRiskTrend > 0, negative: overallRiskTrend < 0 }">
                    Trend: {{ overallRiskTrend }}
                </p>
                <p>Change: {{ overallRiskChangePercentage }}%</p>
            </div>
        </mat-card>

        <mat-card class="chart-card">
            <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
            <app-smooth-line-chart [RiskTrendData]="RiskTrendData"></app-smooth-line-chart>
        </mat-card>
        <!-- <mat-card class="performance-card">
            <mat-card-title>Performance Indicators</mat-card-title>
            <mat-grid-list [cols]="2" rowHeight="130px" gutterSize="16px">
                <mat-grid-tile *ngFor="let indicator of performanceIndicators">
                    <mat-card [ngClass]="getClass(indicator.label)" class="indicator-box">
                        <div class="box-header">
                            <span>{{ indicator.label }}</span>
                            <mat-icon>{{ getIcon(indicator.label) }}</mat-icon>
                        </div>
                        <div class="value">{{ indicator.value }}</div>
                        <div class="subtext" *ngIf="indicator.subtext">{{ indicator.subtext }}</div>
                    </mat-card>
                </mat-grid-tile>
            </mat-grid-list>
        </mat-card> -->
    </div>

    <mat-card class="performance-card">
        <div class="risk-statistics">
            <h3>Risk Statistics</h3>
            <div class="stat-cards">
                <div class="stat-card">
                    <div class="label">Total Incidents</div>
                    <div class="value">{{ totalIncident }}</div>
                </div>
                <div class="stat-card high-risk">
                    <div class="label">High Risk</div>
                    <div class="value">{{ totalCount.categorizedCriticalCount }}</div>
                </div>
                <div class="stat-card medium-risk">
                    <div class="label">Medium Risk</div>
                    <div class="value">{{ totalCount.categorizedMediumCount }}</div>
                </div>
                <div class="stat-card low-risk">
                    <div class="label">Low Risk</div>
                    <div class="value">{{ totalCount.categorizedLowOrNoCount }}</div>
                </div>
            </div>
        </div>

        <div class="risk-categories">
            <h3>Risk Categories</h3>
            <div class="category" *ngFor="let cat of categories">
                <div class="info">
                    <div class="name">{{ cat.name }}</div>
                    <div class="incidents">{{ cat.incidentsCount }} incidents</div>
                </div>
                <div class="trend" [ngClass]="cat.trendDirection">
                    {{ cat.trend }}%
                    <mat-icon *ngIf="cat.trendDirection === 'up'">arrow_upward</mat-icon>
                    <mat-icon *ngIf="cat.trendDirection === 'down'">arrow_downward</mat-icon>
                    <mat-icon *ngIf="cat.trendDirection === 'neutral'">remove</mat-icon>
                </div>
            </div>
            <!-- <div class="category">
                <div class="info">
                    <div class="name">Security</div>
                    <div class="incidents">60 incidents</div>
                </div>
                <div class="trend up">40% <mat-icon>arrow_upward</mat-icon></div>
            </div>
            <div class="category">
                <div class="info">
                    <div class="name">Safety</div>
                    <div class="incidents">45 incidents</div>
                </div>
                <div class="trend down">30% <mat-icon>arrow_downward</mat-icon></div>
            </div>
            <div class="category">
                <div class="info">
                    <div class="name">Maintenance</div>
                    <div class="incidents">45 incidents</div>
                </div>
                <div class="trend neutral">30% <mat-icon>remove</mat-icon></div>
            </div> -->
        </div>
    </mat-card>

    <mat-card class="chart-card">
        <!-- <mat-card-title>Risk Trend Over Time</mat-card-title> -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <mat-card-title>Incident Trends by Category</mat-card-title>
            <div>
                <button mat-button (click)="onRangeChange('1d')">1 Day</button>
                <button mat-button (click)="onRangeChange('1w')">1 Week</button>
                <button mat-button (click)="onRangeChange('1m')">1 Month</button>
                <button mat-button (click)="onRangeChange('1y')">1 Year</button>
            </div>
        </div>
        <app-smooth-line-chart [RiskTrendData]="IncidentTrendsbyCategory"></app-smooth-line-chart>
    </mat-card>

    <!-- Map -->
    <section class="heatmap-section">
        <mat-card class="map-card">
            <mat-card-title>Risk Heatmap</mat-card-title>

            <div class="heatmap-wrapper">
                <app-incident-heat-map class="heatmap" [heatMapAssetData]="riskHeatMapData">
                </app-incident-heat-map>
            </div>
        </mat-card>
    </section>

    <mat-card class="incident-analytics-card">
        <mat-card-title>Categorical Breakdown</mat-card-title>
        <mat-accordion multi>
            <mat-expansion-panel *ngFor="let incident of incidents">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ incident.category }}
                        <div class="score">Score: {{ incident.score }}</div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="summary">
                            <div><strong>Total:</strong> {{ incident.total }}</div>
                            <div class="critical">Critical: {{ incident.critical }}</div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- Metrics Grid -->
                <mat-grid-list [cols]="screenSize == ScreenType.Mobile ? 1 : 2" rowHeight="80px" gutterSize="16px">
                    <mat-grid-tile class="metrics">
                        <mat-card class="indicator-box success">
                            <div class="label">Quickest Response</div>
                            <div class="value">{{ incident.quickest }}</div>
                        </mat-card>
                    </mat-grid-tile>
                    <mat-grid-tile class="metrics">
                        <mat-card class="indicator-box danger">
                            <div class="label">Longest Response</div>
                            <div class="value">{{ incident.longest }}</div>
                        </mat-card>
                    </mat-grid-tile>
                    <mat-grid-tile class="metrics">
                        <mat-card class="indicator-box purple">
                            <div class="label">Weakest Hour</div>
                            <div class="value">{{ incident.weakestHour }}</div>
                        </mat-card>
                    </mat-grid-tile>
                    <mat-grid-tile class="metrics">
                        <mat-card class="indicator-box info">
                            <div class="label">Strongest Occupancy</div>
                            <div class="value">{{ incident.strongestOccupancy }}</div>
                        </mat-card>
                    </mat-grid-tile>
                </mat-grid-list>

                <app-smooth-line-chart [RiskTrendData]="incident.chartData"></app-smooth-line-chart>
                <!-- <app-smooth-line-chart [RiskTrendData]="CategoricalBreakdown"></app-smooth-line-chart> -->

            </mat-expansion-panel>
        </mat-accordion>
    </mat-card>

    <mat-card class="risk-assets-card">
        <h3 class="card-title">High-Risk Assets</h3>

        <div *ngFor="let asset of assets" class="asset-box">
            <div class="asset-info">
                <div class="icon-label">
                    <mat-icon color="warn">warning</mat-icon>
                    <strong>{{ asset.name }}</strong>
                </div>
                <div class="details">
                    <div>Location: {{ asset.location }}</div>
                    <div>Last Incident: {{ asset.lastIncident | date:'M/d/yyyy, h:mm:ss a' }}</div>
                </div>
            </div>
            <div class="risk-score">Risk Score: {{ asset.riskScore }}%</div>
        </div>
    </mat-card>


</div>